<template>
	<van-popup v-model="show" position="bottom">
		<div class="px-30" style="background-color: #1A1A1A;">
			<div class="rounded-20 overflow-hidden" >
				<div @click.stop="setLanguage(item.code)" v-for="item, index in language" :key="index"
					class="h-100  mb-10 flex items-center justify-center rounded-20" style="background-color: #0F0F10;">
					<span class="text-30 text-white">{{ item.language }}</span>
				</div>
			</div>
			<div @click.stop="hide" class="h-100 mt-20 flex items-center justify-center rounded-20" style="background-color: #0F0F10;">
				<span class="text-30 text-#999">{{ $t('弹窗.取消') }}</span>
			</div>
			
		</div>
	</van-popup>
</template>

<script>
import en from '@/lang/en.js';
import zh from '@/lang/zh.js';
import utils from "@/utils/utils.js";
import store from '@/store/index.js';
export default {
	data() {
		return {
			show: false,
			language: [{
				code: 'en',
				language: 'English'
			}, {
				code: 'ja',
				language: '日本語'
			},
			{
				code: 'ko',
				language: '한국어'
			},{
				code: 'zhtw',
				language: '中文-繁体'
			}]
		};
	},
	created() { },
	methods: {
		open() {
			this.show = true
		},
		hide() {
			this.show = false
		},
		setLanguage(code) {
			store.commit('SET_VALUE', {
				key: 'language',
				value: code
			});
			localStorage.setItem('lang', code);
			this.hide()
		}
	},
}
</script>

<style></style>